/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

export const mechanicalSettingsParameters: Record<string, ParameterInfos> = {
  MechanicalSettings_ProbeFrequency: {
    sourceUnit: 'Hz',
    metric: {
      decimals: 2,
      unit: 'MHz',
    },
    imperial: {
      decimals: 2,
      unit: 'MHz',
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_PulserConnector: {
    metric: {
      unit: '',
    },
    imperial: {
      unit: '',
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_ReceiverConnector: {
    metric: {
      unit: '',
    },
    imperial: {
      unit: '',
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_ScanPattern: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_FiringMode: {
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_ScanStart: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_ScanLength: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
      },
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
      limit: {
        min: 0,
      },
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_ScanResolution: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      limit: {
        min: 0.0001,
      },
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      limit: {
        min: 0.0001,
      },
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_IndexStart: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_IndexLength: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
      },
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
      limit: {
        min: 0,
      },
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_IndexResolution: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_SpecimenThickness: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: false,
      },
    },
  },
  MechanicalSettings_SpecimenLength: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.01,
        0.1,
        1,
        10,
      ],
      limit: {
        min: 0,
      },
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
        5,
      ],
      limit: {
        min: 0,
      },
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
  MechanicalSettings_SpecimenWidth: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
      defaultStep: 1,
      steps: [
        0.1,
        1,
        10,
      ],
    },
    imperial: {
      unit: 'in',
      decimals: 3,
      defaultStep: 0.05,
      steps: [
        0.005,
        0.05,
        0.5,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: true,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
};
